import styled from 'styled-components';

export const BodyContainer = styled.div`
  p {
    margin: 7px 2px 5px;
    line-height: 1.4;
    height: 60px;
  }
`;
